//*******************************************************************************************
//* WaMS Component Framework - app.input.js
//* Version 0.11
//* Author: Damian Koch
//* Component framework input helpers plugin
//* Requires jQuery, WaMS Component Framework
//*
//* This component adds some rich input features.  When this file is loaded, certain
//* fields/attributes will be looked for in forms on showEditMode complete.
//* 04/18/22 DBK: Updates to support component framework 1.07
//*******************************************************************************************

import $ from 'jquery';
import { util } from './app.js';
import fileUploaders from './app.fileUploaders.js';
import Autocomplete from './app.autocomplete.js';

const input = {
        Init: function () {
            this.initInputComponents(document);
            //init page

            //init future components
            $(document).on('component-bind-edit-mode-complete', function (e, component) {
                //util.console.log('component-bind-edit-mode-complete triggered: ' + component.type);
                input.initInputComponents(component.editComponent);
            });
        },
        initInputComponents: function (el) {
            input.initMasks(el);
            input.initTextEditor(el);
            input.initDatePicker(el);
            input.initSelectMany(el);
            input.initAutocomplete(el);
            input.initCheckboxLists(el);
            fileUploaders.Init();
            // $(el).foundation();
        },
        initMasks: function (editComponent) {
            $('[data-component-input-type="Phone"]', editComponent).attr('type', 'tel');
            $('[data-component-input-type="phoneext"]', editComponent).attr('type', 'tel');
            $('[data-component-input-type="date"]', editComponent).attr('type', 'date');
            $('[data-component-input-type="numeric"]', editComponent).attr('type', 'number');
            $('[data-component-input-type="percentage"]', editComponent).attr('type', 'number');
            $('[data-component-input-type="currency"]', editComponent).attr('type', 'number');
            $('[data-component-input-type="ssn"]', editComponent).attr('type', 'text').attr('inputmode', 'numeric').attr('maxlength', '11');
        },

        initSelectMany: function (editComponent) {
            $('[data-role="select-many"]', editComponent).each(function () {
                var selectManyContext = this;
                var listSelected = function (el) {
                    var selectedCheckboxNames;
                    var context = $(el).closest('[data-role="select-many"]');
                    var fieldSet = $('fieldset', context);

                    if ($('[type="checkbox"]:not(:checked)', fieldSet).length === 0) {
                        selectedCheckboxNames = 'All';
                    }
                    else {
                        if ($('[type="checkbox"]:checked', fieldSet).length === 0) {
                            selectedCheckboxNames = 'None';
                        } else {
                            selectedCheckboxNames = $('[type="checkbox"]:checked + label', fieldSet).map(function () {
                                return this.innerText;
                            }).get().join(', ');
                        }
                    }

                    $('[data-role="selected-item-list"]', context).text(selectedCheckboxNames);
                };

                listSelected($('fieldset', this));

                //on change update selection list label
                $('input[type="checkbox"]', selectManyContext).on('change', function () { listSelected(this); });

                //filter event listener
                $(selectManyContext).on('input', '[data-role="select-many-filter"]', function () {
                    var value = $(this).val().toLowerCase();
                    const selMany = $(this).closest('[data-role="select-many"]');

                    selMany.find('.select-many-checkbox').each(function () {
                        if ($(this).find('label').text().toLowerCase().search(value) > -1) {
                            $(this).show();
                        }
                        else {
                            $(this).hide();
                        }
                    });

                    var selAll = selMany.find('[type="checkbox"][data-role~="selectall"]:visible');
                    var selAllChecked = true;


                    //loop through visible values, if any is false, then mark the box as not all selected
                    selMany.find('.select-many-checkbox input[type="checkbox"]:visible').each(function (ind, el) {
                        if ($(el).prop('checked') !== true) {
                            selAllChecked = false;
                            // returning false breaks from loop
                            return false;
                        }
                    });

                    selAll.prop('checked', selAllChecked);
                });

                util.console.log(editComponent);

                //custom dropdown filter event listener
                $(editComponent).on('change', 'select[data-role="filter-select-many"]', function () {

                    //var filterField = $(this).data("filter-field");
                    var filterTargetFieldset = $('#fst' + $(this).data('target'), selectManyContext);
                    //var selectedOption = $(this).val();

                    var allSelects = $('select[data-role="filter-select-many"][data-target="' + $(this).data('target') + '"]');

                    filterTargetFieldset.find('.select-many-checkbox').each(function () {
                        var showThis = true;
                        var curCheckbox = $(this).find('input');

                        allSelects.each(function (el) {
                            var selectedOption = $(this).val();
                            var filteredField = $(this).data('filter-field');
                            var filteredFieldValue = curCheckbox.data(filteredField);

                            showThis = showThis && (selectedOption == null || selectedOption === '' || filteredFieldValue == selectedOption);
                        });

                        if (showThis) {
                            $(this).show();
                        }
                        else {
                            $(this).hide();
                        }
                    });

                    var selAll = $('[type="checkbox"][data-role~="selectall"][name="' + $(this).data('target') + '"]:visible');
                    var selAllChecked = true;
                    $('.select-many-checkbox input[type="checkbox"][name="' + $(this).data('target') + '"]:visible').each(function (ind, el) {
                        if ($(el).prop('checked') != true) {
                            selAllChecked = false;
                            // returning false breaks from loop
                            return false;
                        }
                    });

                    selAll.prop('checked', selAllChecked);
                });
            });
        },
        initDatePicker: function (editComponent) {
            //TODO: GET NEW DATE PICKER
            $('[data-component-role="startdate"]', editComponent).datepicker({
                autoclose: true,
                todayHighlight: true
            }).on('changeDate', function (ev) {
                var endDateElement = $('#' + $(this).data('enddate-target'), $(this.form));
                var selectedDate = ev.date;
                var endDate = new Date(endDateElement.val());

                if (selectedDate > endDate) {
                    var newDate = new Date(selectedDate);
                    newDate.setDate(newDate.getDate() + 1);
                    endDateElement.datepicker('setDate', newDate);
                }

                $(this).datepicker('hide');
                endDateElement.focus();
            });

            $('[data-component-role="enddate"]', editComponent).datepicker({
                autoclose: true,
                todayHighlight: true,
                beforeShowDay: function (date) {
                    var startDate = new Date($('[data-enddate-target="' + this.id + '"]').val());
                    return date <= startDate ? 'disabled' : '';
                }
            }).on('changeDate', function () {
                $(this).datepicker('hide');
            });

            // options from: https://bootstrap-datepicker.readthedocs.io/en/stable/options.html
            $('[data-role~="datepicker"]', editComponent).each(function () {
                var $input = $(this);
                var datePickerOptions = {
                    format: 'mm/dd/yyyy',
                    assumeNearbyYear: true,
                    clearBtn: true,
                    autoclose: true
                };

                //// Check for min date attribute
                //if ($input.data('min-date')) {
                //    datePickerOptions.startDate = $input.data('min-date');
                //}

                //// Check for max date attribute
                //if ($input.data('max-date')) {
                //    datePickerOptions.endDate = $input.data('max-date');
                //}

                $input.datepicker(datePickerOptions);
            });
        },
        initTextEditor: function (editComponent) {
            $('[data-role~="richtext"]', editComponent).each(function (index) {
                tinymce.remove('#' + this.id);
                tinyMCE.baseURL = app.page.appPath+ "/tinymce";
                tinymce.init({
                    license_key: 'gpl',
                    relative_urls: false,
                    remove_script_host: false,
                    selector: '#' + this.id, // change this value according to your HTML
                    block_formats:
                        'Paragraph=p;Heading 1=h1;Heading 2=h2;Heading 3=h3;Heading 4=h4;Heading 5=h5;Heading 6=h6;Preformatted=pre',
                    plugins: 'code lists link table',
                    branding: false,
                    menubar: false,
                    toolbar: [
                        'bold italic superscript subscript | formatselect | numlist bullist | forecolor backcolor | alignleft aligncenter alignright | link | indent outdent | removeformat code'
                    ],
                    init_instance_callback: function (editor) {
                        editor.on('change', function (e) {
                            tinymce.triggerSave();
                            $('#' + e.target.id).valid();
                        });
                    }
                });

                //Hook hidden field into the validation
                //Tried setting this on the form on creation, on custom validators.... Would not bind correctly
                //This works the best out of kludge options
                var form = $(this.form);
                if (form != undefined) {
                    //create the validator
                    $.validator.unobtrusive.parse(form);
                    //set validator options
                    var validator = form.data('validator');
                    if (validator !== undefined) {
                        validator.settings.ignore =
                            ':hidden:not([data-role~="richtext"]),.mce-content-body';
                    }
                }
            });
        },
        initAutocomplete: function (editComponent) {
            $('[data-role~="autocomplete"]', editComponent).each(function () {
                var ac = $(this).AutoComplete();
            });
            Autocomplete.BindSetButtons(editComponent);
        },
        initCheckboxLists: function (el) {
            $('[type="checkbox"][data-role~="selectall"]', el).each(function () {
                $('[type="checkbox"][name="' + $(this).attr('name') + '"]').change(function () {
                    if ($(this).attr('data-role') === 'selectall') {
                        $('[type="checkbox"][name="' + $(this).attr('name') + '"]:visible').prop('checked', this.checked);

                    } else {
                        var selAll = $('[type="checkbox"][data-role~="selectall"][name="' + $(this).attr('name') + '"]:visible');

                        //check for all selected, or not all selected
                        if (selAll.is(':checked')) {
                            if (!this.checked) {
                                selAll.prop('checked', this.checked);
                            }
                        } else {
                            if ($('[type="checkbox"][name="' + $(this).attr('name') + '"]:not(:checked)').length === 1) {
                                selAll.prop('checked', this.checked);
                            }
                        }
                    }
                });
            });
            $(document).trigger('component-bindCheckboxLists', el);
        }
};

export default input;
